const config = {
  firebase: {
    config: {
      apiKey: 'AIzaSyDqrxz_LuE44Q6w75Co43d-bDGPqOmxFOI',
      authDomain: 'emetworks-fds-34206.firebaseapp.com',
      databaseURL: 'https://emetworks-fds-34206.firebaseio.com',
      projectId: 'emetworks-fds-34206',
      storageBucket: 'emetworks-fds-34206.appspot.com',
      messagingSenderId: '106010554649',
      appId: '1:106010554649:web:877c94877150172a',
      measurementId: 'G-E9L2DFXXGR',
    },
    messaging: {
      publicKey: 'BKPJwkh-A12Q4mv5KxB_XhaR_RHfYMpTWIH7J4h-UnDxBjcxmpPtjPKqDxjC-ofpsVs8j3yAE4RnKBrQusN21xM',
    },
    status: false,
  },
  api: {
    //url: 'https://dop-apigateway.airpresense.tech',
    //url_auth: 'https://dop-apigateway.airpresense.tech',
    //url_socket: 'https://dop-notification.airpresense.tech',
    url: 'https://webtest003.codesand.cloud',
    url_auth: 'https://webtest003.codesand.cloud',
    url_socket: 'https://webtest006.codesand.cloud',
    version: 'v3/api',
  },
  protocol: 'https',
  vconsole: {
    enabled: false,
  },
  style: {
    useHN: false,
  },
  mapHiding: [4],
  groupNotification: true,
  cache: true,
  configType: true,
  battery: {
    hideBatteryAfter: 1440,
  },
  displayPlaceForEmergency: true,
  features: {
    report: {
      vitalSign: true,
      garmin: true,
    },
    dashboard: {
      roomName: false,
    },
    allPatients: {
      syncNirun: true,
    },
    auth: {
      authMode: 'local', //cognito,local
    },
  },
  headerView: {
    default: 'Pre-Sense System',
    dop: 'กรมกิจการผู้สูงอายุ',
  },
};
module.exports = config;
